import { Component, OnInit, AfterContentInit, OnDestroy, ViewChild, EventEmitter, ElementRef, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal, NgbTabset, NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { ModalLocationEntryService } from './modal-location-entry.service';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { ViewStackComponent } from '../../view-stack/view-stack.component';
import { GeocodeComponent } from '../../location/geocode/geocode.component';
import { SLMap } from 'src/app/model/sl-map';
import { LngLatFormComponent } from '../../location/lng-lat-form/lng-lat-form.component';
import { UtmFormComponent } from '../../location/utm-form/utm-form.component';
import { DictHandler, GeoLoc } from 'src/app/types/@types/sl-v-types';
import { InfoAction } from 'src/app/model/map-actions/info-action';
import { BufferSrc, BufferUnits } from 'src/app/model/buffersrc';
import { BufferFormComponent } from '../../buffer-form/buffer-form.component';


@Component({
  selector: 'app-modal-location-entry-content',
  templateUrl: './modal-location-entry.component.html',
  styleUrls: ['./modal-location-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalLocationEntryContentComponent implements OnInit, AfterContentInit {

  private map: SLMap;
  @HostBinding('class.work-view') workView = true;
  @ViewChild('views', { static: true }) views !: ViewStackComponent;
  @ViewChild('tabs', { static: true }) tabs !: NgbTabset;
  @ViewChild('buttonOne', { static: true }) buttonOne: ElementRef;
  @ViewChild('buttonTwo', { static: true }) buttonTwo: ElementRef;

  @ViewChild(GeocodeComponent, { static: true }) geoCodeView: GeocodeComponent;
  @ViewChild(LngLatFormComponent, { static: true }) latLonView: LngLatFormComponent;
  @ViewChild(UtmFormComponent, { static: true }) utmView: UtmFormComponent;

  public isAdvanced: boolean = false;
  public userZoom?: number | string = 'auto';
  public triggerQuery: boolean = false;
  public actions: EventEmitter<any> = new EventEmitter();
  private handler: DictHandler;

  public subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
  @ViewChild('bufferInput') bufferInput: BufferFormComponent;
  public buffer: BufferSrc = new BufferSrc(0, 'ft');
  public get bufferValue() {
    return this.buffer.buffer;
  }
  public set bufferValue(val: any) {
    if (this.buffer.buffer === val) return;
    this.buffer.buffer = val;
    this.Refresh();
  }

  public get bufferUnits(): BufferUnits {
    return this.buffer.units;
  }
  public set bufferUnits(val: BufferUnits) {
    if (this.buffer.units === val) return;
    this.buffer.units = val;
    this.Refresh();
  }
  public get bufferVis(): boolean {
    return this.isAdvanced && this.triggerQuery;
  }
  public includeBuffer: boolean = false;
  private _ready: boolean = false;
  constructor(private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef) { }

  ngOnInit() {

  }
  ngAfterContentInit() {
    this._ready = true;
    this.subscriptionMgr.Subscribe(this.tabs.tabChange, (data: NgbTabChangeEvent) => {
      let tabIdParts = data.nextId.split('-');
      tabIdParts.shift(); // remove modal-
      tabIdParts.shift(); // remove -loc-
      tabIdParts.pop(); // remove -loc
      this.ShowView(tabIdParts.join('-'));
    });
    this.buttonOne.nativeElement.addEventListener('click', () => {
      this.HandleButtonOne();
    });
    this.buttonTwo.nativeElement.addEventListener('click', () => {
      this.activeModal.close();
    });
    window.requestAnimationFrame(() => {
      this.buffer = !!InfoAction.bufferSrc ? JSON.parse(JSON.stringify(InfoAction.bufferSrc)) : new BufferSrc(0, 'ft');
      this.bufferInput.SetBufferValue(this.buffer.buffer, this.buffer.units);
      this.Refresh();
    })
  }
  Refresh() {
    if (this._ready === false) return;
    this.cdr.detectChanges();
  }
  ShowView(viewName: string) {
    this.views.SetView(viewName);

  }
  Show(info: any) {
    this.ShowView(info.type);
    if (info.handler) {
      this.handler = info.handler;
    }
    if (info.map) {
      this.map = info.map;
      this.geoCodeView.SetUp(this.map, () => {
        this.HandleButtonOne();
      });
      this.latLonView.SetUp(this.map, () => {
        this.HandleLngLatOk();
      });
      this.utmView.Setup(this.map, () => {
        this.HandleButtonOne();
      });
    }
    this.Refresh();
  }
  HandleLngLatOk() {
    const loc: GeoLoc = this.latLonView.value;
    if (this.isAdvanced) {
      if (this.userZoom !== 'auto') {
        loc.zoom = Number(this.userZoom);
      }
    }
    InfoAction.SimClick(this.map.component, { pt: this.latLonView.value.point });

    this.handler({ action: 'navigation/jump-to-geoloc/', data: this.latLonView.value, autoPuc: !!this.triggerQuery });
    if (this.triggerQuery) {
      this.map.ui.once('idle', () => {
        const buffer = this.bufferInput.GetBufferSrc();
        const params: any = this.includeBuffer ? { buffer: buffer } : {};

        InfoAction.Exec('query', this.map.component, params);
        this.activeModal.close();
      });
    } else {
      this.activeModal.close();
    }

  }
  HandleGeoLoc() {
    const loc: GeoLoc = this.geoCodeView.currentValue;
    if (this.isAdvanced) {
      if (this.userZoom !== 'auto') {
        loc.zoom = Number(this.userZoom);
        loc.bbox = undefined;
      }
      loc.autoQuery = this.triggerQuery;

    } else {
      loc.autoQuery = false;
    }
    this.handler({ action: 'navigation/jump-to-geoloc/', data: loc });
    if (this.triggerQuery) {
      this.map.ui.once('idle', () => {
        const buffer = this.bufferInput.GetBufferSrc();
        const params = this.includeBuffer ? { buffer: buffer } : {};
        InfoAction.Exec('query', this.map.component, params);
        this.activeModal.close();
      });
    } else {
      this.activeModal.close();
    }
  }

  HandleButtonOne() {
    switch (this.views.selectedView) {
      case 'search':
        // this.geoCodeView.SetUp(this.map);
        this.HandleGeoLoc();
        break;
      case 'latlon':
        this.latLonView.Submit();
        return;

      case 'utm':
        this.handler({ action: 'navigation/jump-to-geoloc/', data: this.utmView.value });
        break;
    }

    this.activeModal.close();
  }

}

@Component({
  selector: 'app-modal-location-entry',
  template: ''
})
export class ModalLocationEntryComponent implements OnDestroy {
  modalRef: NgbModalRef;
  subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
  lastTitle: string | null = null;

  constructor(private modalService: NgbModal, private service: ModalLocationEntryService) {

    this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
      this.modalRef = this.modalService.open(ModalLocationEntryContentComponent, { backdrop: 'static', windowClass: 'location-modal' });
      (this.modalRef.componentInstance as ModalLocationEntryContentComponent).Show(info);
    });


  }
  ngOnDestroy() {

  }
}
